<template>
  <div class="oec-execute-form">
    <div class="content">
      <div class="table-content atb-flex atb-flex-column">
        <vxe-table
          class='atb-table header-table edit-table'
          border='inner'
          height='100%'
          ref="handled"
          auto-resize
          :data="tableData"
        >
          <vxe-table-column type="seq" width="60" title="序号"></vxe-table-column>
          <vxe-table-column field="wkNo" width="80" title="工号"></vxe-table-column>
          <vxe-table-column field="wkName" width="120" title="姓名"></vxe-table-column>
          <vxe-table-column field="superiorNo" width="80" title="上级工号"></vxe-table-column>
          <vxe-table-column field="superiorName" width="120" title="上级姓名"></vxe-table-column>
          <vxe-table-column field="noExecuteForm" min-width="250" title="未执行表格">
            <template #default="{row}">
              <div>
                <el-link
                  :underline="false"
                  class="form-link"
                  type="danger"
                  v-for="item in (row.nonExecutedTitle || [])"
                  :key="item"
                  :label="item"
                  :value="item"
                  >{{ '&lt;&lt;' + item + '&gt;&gt;' }}</el-link>
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="handlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <div class="btn-wrap">
      <el-button type="primary" class="btn" @click="exportExcel">导出</el-button>
      <el-button type="clear" class="btn" @click="$parent.$parent.hide()">关闭</el-button>
    </div>
  </div>
</template>
<script>
import XEUtils from 'xe-utils'
export default {
  name: 'OECDeptExecuteForm',
  props: {
    date: String,
    msgObjectChildId: String
  },
  data() {
    return {
      tableData: [],
      page: {
        PageIndex: 1,
        PageSize: 50,
      },
      total: 0,
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      const pageParam = { groupId: this.msgObjectChildId, pageIndex: this.page.PageIndex, pageSize: this.page.PageSize };
      this.$ajax.post(this.$api.Identity.deptNotification.noticeDeptExeList, pageParam).then((res) => {
        const tableData = res.data.rows;
        tableData.forEach(item => {
          item.expandRowFlag = false;
        })
        this.tableData = tableData;
        this.total = res.data.total;
      });
    },
    formatDate(value, format) {
      return XEUtils.toDateString(value, format)
    },
    handlePageChange({ currentPage }) {
      this.page.pageIndex = currentPage;
      this.getList();
    },
    exportExcel() {
      this.$ajax.get(this.$api.Identity.deptNotification.exportFileExeNotice, { groupId: this.msgObjectChildId }).then((res) => {
        if (res.code === 0) {
          this.$router.push({
            path: '/manage/export-task/index',
          });
        }
        // if (res.data.type == 'application/json') {
        //   var reader = new FileReader();
        //   reader.onload = () => {
        //     var content = reader.result;//内容就在这里
        //     let json = JSON.parse(content)
        //     this.$message.error(json.message)
        //   };
        //   reader.readAsText(res.data);
        // } else {
        //   const filename = '部门执行表格提醒'
        //   const filetype = 'xlsx'
        //   let data = res.data;
        //   let url = window.URL.createObjectURL(data)
        //   let a = document.createElement('a')
        //   document.body.appendChild(a)
        //   a.href = url
        //   a.download = filename + '.' + filetype
        //   a.click()
        //   window.URL.revokeObjectURL(url)
        // }
      });
    }
  },
}
</script>
<style scoped lang='scss'>
.oec-execute-form {
  .table-content {
    height: 400px;
  }
  .el-button.el-button--clear {
    background-color: #F5BF2B;
    border-color: #F5BF2B;
    color: #ffffff;
  }
  .el-button {
    width: 110px;
    border-radius: 10px;
  }

  .btn-wrap {
    text-align: right;
    margin-top: 10px;
  }

  .form-link {
    cursor: default;
  }
  ::v-deep .header-table {
    table {
      height: 100%;
    }
    overflow: auto;
    flex-grow: 1;

    .vxe-table--header-wrapper {
      background-color: $--bg-color-complete !important;
    }
  }
}
</style>